import { Button, CircularProgress } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { useTranslation } from 'react-i18next'
import type { ReactNode } from 'react'

type buttonProps = {
  onClick?: () => void
  title?: string
  color?: 'error' | 'inherit' | 'success' | 'primary' | 'secondary' | 'info' | 'warning'
  className?: string
  disabled?: boolean
  isLoading?: boolean
  icon?: ReactNode
  size?: 'small' | 'medium' | 'large' | undefined
  style?: React.CSSProperties
}
export const SearchButton = ({ onClick, isLoading, size, title, color, icon, style, ...props }: buttonProps) => {
  const { t: transAction } = useTranslation()

  return (
    <Button
      {...props}
      variant="contained"
      color={color}
      onClick={onClick}
      size={size}
      startIcon={isLoading ? <CircularProgress size={20} color={'inherit'} /> : icon || <SearchIcon />}
      style={style}
    >
      {transAction(title || 'BUSCAR')}
    </Button>
  )
}
